import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { formatDate } from "../../utils/formatDate";
import { STATUS } from "../../components/constants/statuses";
import axiosAdmin from "../../api/axiosAdmin";

const RequestsPage = () => {
  const [requests, setRequests] = useState([]);
  const [statusFilter, setStatusFilter] = useState("");
  const [djFilter, setDjFilter] = useState("");
  const [dateFilter, setDateFilter] = useState("");
  const [page, setPage] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [showFilters, setShowFilters] = useState(false);

  useEffect(() => {
    fetchRequests();
  }, [statusFilter, djFilter, dateFilter, page]);

  useEffect(() => {
    setPage(0);
  }, [statusFilter, djFilter, dateFilter]);

  const fetchRequests = async () => {
    try {
      const response = await axiosAdmin.get("/request/all", {
        params: {
          status: statusFilter || undefined,
          page,
          size: 15,
        },
      });

      setRequests(response.data.content);
      setTotalPages(response.data.totalPages);
    } catch (error) {
      console.error("Error fetching requests:", error);
    }
  };

  const handlePageChange = (newPage) => {
    setPage(newPage);

    const main = document.querySelector("main");

    if (main) {
      main.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  return (
    <div>
      <h1 className="text-2xl font-bold mb-4">Requests</h1>

      <div className="mb-4">
        <button
          onClick={() => setShowFilters(!showFilters)}
          className="md:hidden bg-blue-500 text-white px-4 py-2 rounded-lg w-full"
        >
          Filters
        </button>

        <div className="hidden md:flex space-x-4">
          <select
            value={statusFilter}
            onChange={(e) => setStatusFilter(e.target.value)}
            className="p-2 border rounded-lg"
          >
            <option value="">All Statuses</option>
            <option value="pending">Pending</option>
            <option value="approved">Approved</option>
            <option value="paid">Paid</option>
            <option value="played">Played</option>
            <option value="rejected">Rejected</option>
          </select>

          <input
            type="text"
            placeholder="DJ Name"
            value={djFilter}
            onChange={(e) => setDjFilter(e.target.value)}
            className="p-2 border rounded-lg"
          />

          <input
            type="date"
            value={dateFilter}
            onChange={(e) => setDateFilter(e.target.value)}
            className="p-2 border rounded-lg"
          />
        </div>

        {showFilters && (
          <div className="md:hidden mt-2 p-4 bg-gray-100 rounded-lg space-y-2">
            <select
              value={statusFilter}
              onChange={(e) => setStatusFilter(e.target.value)}
              className="w-full p-2 border rounded-lg"
            >
              <option value="">All Statuses</option>
              <option value="pending">Pending</option>
              <option value="approved">Approved</option>
              <option value="paid">Paid</option>
              <option value="played">Played</option>
              <option value="rejected">Rejected</option>
            </select>

            <input
              type="text"
              placeholder="DJ Name"
              value={djFilter}
              onChange={(e) => setDjFilter(e.target.value)}
              className="w-full p-2 border rounded-lg"
            />

            <input
              type="date"
              value={dateFilter}
              onChange={(e) => setDateFilter(e.target.value)}
              className="w-full p-2 border rounded-lg"
            />
          </div>
        )}
      </div>

      <table className="hidden md:table w-full border-collapse">
        <thead>
          <tr className="bg-gray-100">
            <th className="p-2 border">Artist</th>
            <th className="p-2 border w-1/4">Track</th>
            <th className="p-2 border">DJ</th>
            <th className="p-2 border w-1/6">User message</th>
            <th className="p-2 border">Dj message</th>
            <th className="p-2 border">Price (PLN)</th>
            <th className="p-2 border">Date</th>
            <th className="p-2 border">Status</th>
            <th className="p-2 border">Actions</th>
          </tr>
        </thead>
        <tbody>
          {requests.map((request) => (
            <tr key={request.id} className="hover:bg-gray-50">
              <td className="p-2 border">{request.artist}</td>
              <td className="p-2 border">{request.trackName}</td>
              <td className="p-2 border">{request.djName}</td>
              <td className="p-2 border">{request.message}</td>
              <td className="p-2 border">{request.djMessage}</td>
              <td className="p-2 border text-center">{request.price}</td>
              <td className="p-2 border text-center">
                {formatDate(request.createdAt)}
              </td>
              <td className="p-2 border text-center">
                <span
                  className={`px-2 py-1 rounded text-xs font-semibold ${
                    request.status === STATUS.PENDING
                      ? "bg-gray-200 text-gray-800"
                      : request.status === STATUS.APPROVED
                      ? "bg-yellow-200 text-yellow-800"
                      : request.status === STATUS.PAID
                      ? "bg-green-200 text-green-800"
                      : request.status === STATUS.REJECTED
                      ? "bg-red-200 text-red-800"
                      : "bg-blue-200 text-blue-800"
                  }`}
                >
                  {request.status}
                </span>
              </td>
              <td className="p-2 border text-center">
                <Link
                  to={`/admin-panel/requests/${request.id}`}
                  className="text-blue-500"
                >
                  View
                </Link>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      <div className="md:hidden space-y-4 py-4">
        {requests.map((request) => (
          <div
            key={request.id}
            className="w-full border rounded-lg p-4 shadow-md bg-white"
          >
            <div className="flex justify-between items-center mt-1">
              <span
                className={`ml-auto px-2 py-1 rounded text-xs font-semibold ${
                  request.status === STATUS.PENDING
                    ? "bg-gray-200 text-gray-800"
                    : request.status === STATUS.APPROVED
                    ? "bg-yellow-200 text-yellow-800"
                    : request.status === STATUS.PAID
                    ? "bg-green-200 text-green-800"
                    : request.status === STATUS.REJECTED
                    ? "bg-red-200 text-red-800"
                    : "bg-blue-200 text-blue-800"
                }`}
              >
                {request.status}
              </span>
            </div>
            <div className="font-bold text-lg mt-1">{request.trackName}</div>
            <div className="text-sm text-gray-500">
              Artist: {request.artist}
            </div>
            <div className="text-sm text-gray-500 mt-2">
              DJ: {request.djName}
            </div>
            <div className="text-sm text-gray-500">
              Location: {request.place.name}
            </div>
            <div className="text-sm text-gray-500">
              Price: {request.price} PLN
            </div>
            <div className="flex justify-between items-center">
              <span className="text-xs text-gray-500">
                {formatDate(request.createdAt)}
              </span>
              <Link
                to={`/admin-panel/requests/${request.id}`}
                className="text-blue-500"
              >
                View
              </Link>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-4 flex justify-center items-center space-x-1">
        <button
          onClick={() => handlePageChange(page - 1)}
          disabled={page === 0}
          className="px-3 py-2 bg-gray-300 rounded-lg disabled:opacity-50 hidden md:block"
        >
          ←
        </button>

        {page > 2 && (
          <>
            <button
              onClick={() => handlePageChange(0)}
              className={`px-3 py-2 rounded-lg ${
                page === 0 ? "bg-blue-500 text-white" : "bg-gray-300"
              }`}
            >
              1
            </button>
            {page > 3 && <span className="px-2">...</span>}
          </>
        )}

        {[...Array(totalPages).keys()]
          .slice(Math.max(0, page - 2), Math.min(totalPages, page + 3))
          .map((pageNum) => (
            <button
              key={pageNum}
              onClick={() => handlePageChange(pageNum)}
              className={`px-3 py-2 rounded-lg ${
                pageNum === page ? "bg-blue-500 text-white" : "bg-gray-300"
              }`}
            >
              {pageNum + 1}
            </button>
          ))}

        {page < totalPages - 3 && (
          <>
            {page < totalPages - 4 && <span className="px-2">...</span>}
            <button
              onClick={() => handlePageChange(totalPages - 1)}
              className={`px-3 py-2 rounded-lg ${
                page === totalPages - 1
                  ? "bg-blue-500 text-white"
                  : "bg-gray-300"
              }`}
            >
              {totalPages}
            </button>
          </>
        )}

        <button
          onClick={() => handlePageChange(page + 1)}
          disabled={page >= totalPages - 1}
          className="px-3 py-2 bg-gray-300 rounded-lg disabled:opacity-50 hidden md:block"
        >
          →
        </button>
      </div>
    </div>
  );
};
export default RequestsPage;
